export default function CapitalDisplay({ currentCapital, unrealizedPnl, equity }) {
  const fmt = (n) =>
    n != null ? n.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '—';

  const pnlClass = unrealizedPnl > 0 ? 'capital-positive' : unrealizedPnl < 0 ? 'capital-negative' : '';
  const pnlSign = unrealizedPnl > 0 ? '+' : '';

  return (
    <div className="capital-display">
      <span className="capital-equity" title="Equity">{fmt(equity)}</span>
      <span className={`capital-unrealized ${pnlClass}`} title="Unrealized P&L">
        {pnlSign}{fmt(unrealizedPnl)}
      </span>
    </div>
  );
}
